import styles from './EntryList.module.css';
import { TrackingCode } from './TrackingCode.tsx';

export type Entry = {
  readonly key: string;
  readonly value: string | null;
  readonly ltr?: boolean;
  readonly trackingCode?: boolean;
};

export type EntryListProps = { entries: readonly Entry[]; labelOf: (key: string) => string };

const EntryValue = ({ entry }: { entry: Entry }) => {
  if (entry.value === null) return '—';
  if (entry.trackingCode === true) return <TrackingCode code={entry.value} />;
  if (entry.ltr === true) return <bdi dir="ltr">{entry.value}</bdi>;
  return entry.value;
};

export const EntryList = ({ entries, labelOf }: EntryListProps) => (
  <dl className={styles['entries']}>
    {entries.map((entry) => (
      <div key={entry.key} className={styles['entry']}>
        <dt>{labelOf(entry.key)}</dt>
        <dd>
          <EntryValue entry={entry} />
        </dd>
      </div>
    ))}
  </dl>
);
